<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="text-center" :to="{ path: '/sys/linXuanChannel/list' }"
      >商户审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
        class="flex-item role-form"
        ref="validateForm"
        :model="form"
        size="mini"
        :rules="rules"
        :validate-on-rule-change="false"
        label-width="200px"
    >
      <el-row>
        <!--新增/修改商户信息-->
        <div >
          <el-col :span="8">
            <el-form-item label="统一社会信用代码:" prop="channelName">
              <el-input value="91310106575864243X" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售企业名称:" prop="channelName">
              <el-input value="商户A" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属地区:" prop="channelName1">
              <el-input value="海淀区" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="注册地址:" prop="channelName1">
              <el-input value="海淀区" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属集团:" prop="channelName1">
              <el-input value="联想集团" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业规模:" prop="channelName1">
              <el-input value="中型" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="企业性质:" prop="channelName1">
              <el-input value="股份合作企业" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人:" prop="channelName1">
              <el-input value="张三" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:" prop="channelName1">
              <el-input value="13456588555" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="销售企业资料:" prop="technicalEmail">
            <el-link type="primary" @click="download" v-if="auditType==='5'">销售企业请退出说明.pdf&nbsp;&nbsp;&nbsp;</el-link>
            <el-link type="primary" @click="download">参与补贴实施的门店信息汇总表.xls&nbsp;&nbsp;&nbsp;</el-link>
            <el-link type="primary" @click="download">营业执照复印件.pdf&nbsp;&nbsp;&nbsp;</el-link><br>
            <el-link type="primary" @click="download">企业《信用信息报告》.pdf&nbsp;&nbsp;&nbsp;</el-link>
            <el-link type="primary" @click="download">承诺函.pdf&nbsp;&nbsp;&nbsp;</el-link>
            <el-link type="primary" @click="download">同意函.pdf&nbsp;&nbsp;&nbsp;</el-link>
          </el-form-item>
        </div>
        <!--商户退出-->
        <div v-if="operatorType==='declare' && declareType==='M03'">
          <el-col :span="24">
            <el-form-item label="商户退出汇总表:" prop="merchantFile">
              <el-link type="primary" @click="download">商户退出汇总表.xls</el-link>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
      <el-button size="mini" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import {
  list
} from "@/api/system/linXuanChannel/linXuanChannel";

export default {
  name: "index",
  data() {
    return {
      userName:'',
      operator:'',
      declareType:'',
      isReadOnly:false,
      auditType:'',
    };
  },
  mounted() {
    this.operator=this.$route.params.operator;
    this.auditType=this.$route.params.auditType;
    if(this.operator=='detail'){
      this.isReadOnly = true;
    }
    this.declareType=this.$route.params.declareType;
    this.userName=this.$store.state.token;
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    back() {
      this.$router.go(-1);
    },
    save() {
      this.$router.push({
        path: '/sys/channelDeclare/list'
      });
    },
    download(){
      this.$message('开发中');
    }
  },
};
</script>
<style scoped>
.el-card {
  height: 100%;
}
.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}
.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.flex-item:nth-child(1),
.flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
}
.flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}
.role-form {
  margin: 15px 0;
}
.el-form-item {
  margin-bottom: 7px;
}
.el-form-item__label {
  line-height: 1.0;
}
.el-form-item__content {
  line-height: 1.0;
}
/* 可选：调整标题栏布局，让按钮靠右 */
::v-deep .custom-accordion .el-accordion-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 去掉默认标题文字的多余样式 */
::v-deep .custom-accordion .el-accordion-item__header-text {
  display: none;
}
</style>